var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_box check"},[_c('div',{staticClass:"checkbox_wrap",on:{"click":_vm.eventEmit}},[_vm._t("checkboxMainTitle",function(){return [_vm._m(0),_c('button',{staticClass:"seedetail_icon"})]})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"checkbox24_icon"}),_c('div',[_vm._v("default")])])
}]

export { render, staticRenderFns }